import { render, staticRenderFns } from "./DataViewSidebarEquipements.vue?vue&type=template&id=2b0ea039&scoped=true&"
import script from "./DataViewSidebarEquipements.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarEquipements.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarEquipements.vue?vue&type=style&index=0&id=2b0ea039&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ea039",
  null
  
)

export default component.exports